import { mapDTO } from '@twistezo/ts-dto-mapper'

import type { RichPlacementKWordsSlice } from '../types'
import type { RichPlacementKWordsDTO } from './types'

type From = RichPlacementKWordsDTO
type To = RichPlacementKWordsSlice

export const fromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform(
    ({ kwordsSiteId }: From): To => ({
      kwordsSiteId: kwordsSiteId ?? undefined,
    }),
  )
